import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  container: {
    position: "absolute",
    bottom: "1.5rem",
  },
  openBtn: (props: any) => ({
    position: "relative",
    opacity: props.isMouseOver ? 1 : 0,
    transition: "all 300ms ease-in-out",
    width: "13rem",
    height: "3rem",
    color: theme.darkSlateGrayColor,
    backgroundColor: theme.whiteColor,
    border: `1px solid ${theme.darkSlateGrayColor}`,
    borderRadius: "1.5rem",
    outline: "none",
    cursor: "pointer",
    textTransform: "uppercase",
    fontFamily: theme.fontFamilyArchivo,
    zIndex: 1,
    "&:hover": {
      color: theme.whiteColor,
      backgroundColor: theme.darkSlateGrayColor,
    },
  }),
  quickView: (props: any) => ({
    position: "fixed",
    top: "calc(50% - 17rem)",
    left: "calc(50% - 27rem)",
    display: props.open ? "flex" : "none",
    width: "54rem",
    height: "34rem",
    zIndex: 6,
    transition: "all 3s ease-in-out",
  }),
  closeBtn: {
    position: "absolute",
    top: "0.5rem",
    right: "0.75rem",
    padding: "1rem",
    textTransform: "uppercase",
    fontFamily: theme.fontFamilyArchivo,
    cursor: "pointer",
    zIndex: 5,
  },
  content: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: "100%",
    padding: "2.5rem 3rem",
    gap: "2rem",
    borderRadius: "20px",
    backgroundColor: theme.whiteColor,
    zIndex: 4,
  },
  contentAfter: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: theme.grayColor,
    opacity: 0.6,
    zIndex: 3,
  },
  imagesContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    minWidth: "24rem",
  },
  largeImage: (props: any) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    minHeight: "24rem",
    backgroundColor: theme.whiteSmokeColor,
    background: `no-repeat center/100% url(${
      props.images?.[props.currentImageStep]?.url
        ? props.images?.[props.currentImageStep]?.url
        : props.images?.[props.currentImageStep]
    })`,
    border: "none",
  }),
  smallImages: {
    display: "flex",
    height: "100%",
    width: "24rem",
    gap: "0.2rem",
    marginTop: "0.5rem",
    overflowX: "auto",
    paddingBottom: "0.2rem",

    "&::-webkit-scrollbar": {
      height: "0.4rem",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.snowColor,
      borderRadius: "0.2rem",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      backgroundColor: theme.gainsboroColor,
    },
  },
  smallImage: {
    minWidth: "4.3rem",
    maxWidth: "4.3rem",
    height: "100%",
    objectFit: "cover",
    cursor: "pointer",
  },
  badgeContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    justifyContent: "flex-start",
    height: "2rem",
  },
  badge: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "6rem",
    fontSize: "0.8rem",
    textTransform: "uppercase",
  },
  soldoutBadge: {
    color: theme.darkSlateGrayColor,
    backgroundColor: theme.khakiColor,
  },
  popularBadge: {
    color: theme.snowColor,
    backgroundColor: theme.darkSlateGrayColor,
  },
  onsaleBadge: {
    color: theme.lightCoralColor,
    backgroundColor: theme.linenColor,
  },
  infoAndAddToCartContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
  },
  infoContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
    height: "max-content",
    maxHeight: "30%",
    overflowY: "auto",
    marginBottom: "1rem",

    "&::-webkit-scrollbar": {
      width: "0.2rem",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.snowColor,
      borderRadius: "0.2rem",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      backgroundColor: theme.gainsboroColor,
    },
  },
  discountedPrice: {
    color: theme.lightCoralColor,
  },
  price: (props: any) => ({
    marginLeft: "0.3rem",
    textDecoration: props.isOnSale ? "line-through" : "none",
    color: props.isOnSale ? theme.darkGrayColor : theme.darkSlateGrayColor,
  }),
  horizontalBorder: {
    margin: "0.9rem 0",
    borderBottom: `1px solid ${theme.snowColor}`,
  },
  firstHr: {
    // marginTop: "auto",
  },
  secondHr: {
    marginBottom: "auto",
  },
  optionsAndisSoldOut: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    height: "max-content",
    maxHeight: "45%",
    width: "22rem",
  },
  sizeOrColorOptions: {
    display: "flex",
    flexDirection: "column",
    rowGap: "0.3rem",
    width: "100%",
    marginTop: "1.2rem",
    paddingRight: "0.1rem",
    overflowY: "auto",

    "&::-webkit-scrollbar": {
      width: "0.2rem",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.snowColor,
      borderRadius: "0.2rem",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      backgroundColor: theme.gainsboroColor,
    },
  },
  optionContainer: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
    rowGap: "0.2rem",
  },
  optionLabel: {
    fontSize: "0.8rem",
    color: theme.darkSlateGrayColor,
    fontFamily: theme.fontFamilyArchivo,
    textTransform: "uppercase",
  },
  selectedOption: {
    fontSize: "0.8rem",
    fontFamily: theme.fontFamilyLexendDeca,
    textTransform: "capitalize",
  },
  options: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    overflowX: "auto",
    columnGap: "0.4rem",
    paddingBottom: "0.1rem",

    "&::-webkit-scrollbar": {
      height: "0.2rem",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.snowColor,
      borderRadius: "0.2rem",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      backgroundColor: theme.gainsboroColor,
    },
  },
  isSoldOut: {
    position: "absolute",
    top: 0,
    right: 0,
    fontSize: "0.8rem",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  addToCartContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    rowGap: "0.5rem",
    height: "max-content",
    maxHeight: "25%",
  },
  quantityContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "30%",
  },
  quantityText: {
    fontSize: "0.8rem",
    textTransform: "uppercase",
    marginBottom: "0.6rem",
  },
  quantityControl: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "60%",
    borderRadius: "5px",
    border: `1px solid ${theme.snowColor}`,
  },
  quantity: {
    fontSize: "0.8rem",
    width: "7rem",
    height: "100%",
    border: "none",
    textAlign: "center",
    "&::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&:disabled": {
      backgroundColor: theme.whiteColor,
    },
  },
  addOrRemoveBtn: {
    height: "100%",
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    padding: "0.6rem 0.9rem",
    fontFamily: theme.fontFamilyArchivo,
  },
  addToCartBtn: (props: any) => ({
    height: "2.8rem",
    border: "none",
    borderRadius: "7px",
    color:
      props?.isSoldOut ||
      props.quantity === 0 ||
      !props.selectedProductOrVariant ||
      props.selectedProductOrVariant === "CHOOSE_OPTION" ||
      props.selectedProductOrVariant === "UNAVAILABLE" ||
      props.quantity > props.stock
        ? theme.darkGrayColor
        : theme.whiteColor,
    background:
      props.isSoldOut ||
      props.quantity === 0 ||
      !props.selectedProductOrVariant ||
      props.selectedProductOrVariant === "CHOOSE_OPTION" ||
      props.selectedProductOrVariant === "UNAVAILABLE" ||
      props.quantity > props.stock
        ? theme.snowColor
        : `linear-gradient(to right, ${theme.blanchedAlmondColor}, ${theme.peachPuffColor})`,
    textTransform: "uppercase",
    fontSize: "0.9rem",
    fontWeight: 500,
    fontFamily: theme.fontFamilyArchivo,
    cursor:
      props.isSoldOut ||
      props.quantity === 0 ||
      !props.selectedProductOrVariant ||
      props.selectedProductOrVariant === "CHOOSE_OPTION" ||
      props.selectedProductOrVariant === "UNAVAILABLE" ||
      props.quantity > props.stock
        ? "not-allowed"
        : "pointer",
  }),
}));

export default useStyles;
